<template>
    <div class="view performance-productivity">
        <app-sub-navbar parent="performance"></app-sub-navbar>
        <div class="container-fluid">
            <app-graph-filter ref="filter" class="text-center" @filterLoaded="update()" @filterChanged="update()" parent="performance"></app-graph-filter>
            <div class="row">
                <div class="col-12">
                    <!-- STORE PRODUCTIVITY -->
                    <el-card class="box-card mt-50 mb-50" v-loading="topLoading">
                        <div slot="header" class="text-left">
                            <h4 class="inline mr-5-howrly">Store ranking</h4>
                            <el-radio-group v-model="productivitySwitch" size="medium" class="vertical-center switch-right fr ml-5-howrly">
                                <el-radio-button label="AOV"></el-radio-button>
                                <el-radio-button label="Conv"></el-radio-button>
                                <el-radio-button label="ROI"></el-radio-button>
                                <el-radio-button label="Prod"></el-radio-button>
                            </el-radio-group>
                            <el-select v-model="numRecords" class="fr" style="width: 120px;">
                                <el-option :value="storeTableData.length" label="All"></el-option>
                                <el-option :value=10 label="Top 5"></el-option>
                                <el-option :value=20 label="Top 10"></el-option>
                                <el-option :value=30 label="Top 15"></el-option>
                            </el-select>
                        </div>
                        <el-table :header-cell-style="columnStyling" :cell-style="cellStyling" :row-class-name="tableRowClassName" :data="filteredStoreTableData" ref="storeProductivityTable" @row-click="storeRowClicked">
                            <el-table-column
                                label="Rank"
                                key="Rank"
                                prop="Rank"
                            >

                            </el-table-column>
                            <el-table-column
                                v-for="col in storeTableHeaders"
                                :key="col.key"
                                :prop="col.prop"
                                :label="col.label"
                                :formatter="formatter"
                            >
                            </el-table-column>
                        </el-table>
                    </el-card>

                    <el-card class="box-card mt-50 mb-50" v-if="storeLoaded && employeeLoaded" v-loading="bottomLoading">
                        <div slot="header" class="text-left">
                            <h4 class="inline">Details for store {{storeSelected}}</h4>
                            <el-button plain size="medium" style="display: inline-block; float: right;" type="primary" @click="collapse = !collapse"><span v-if="collapse">Hide graph</span><span v-else>Show graph</span></el-button>
                        </div>
                        <div class="collapse" :style="collapse === false ? 'display: none' : 'display: block'">
                            <h5 class="inline fl mb-20" style="font-weight: 600;">{{getVariableName() | formatVariableName}} over time</h5>
                            <app-chart-component ref="chartstore" :store="storeSelected" title="productivitystoredetail" storeModule='performance' endpoint="/performance/productivity/store_detail"></app-chart-component>
                            <el-divider></el-divider>
                        </div>
                        <h5 class="inline fl mb-20" style="font-weight: 600;">Active employees</h5>
                        <el-table :header-cell-style="columnStyling" :cell-style="cellStyling" :data="employeeTableData" v-on:expand-change='collapseOpenRow' @row-click="rowClicked" ref="employeeProductivityTable">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <div class="row">
                                        <div class="col-6">
                                            <app-chart-component ref="chartemployee" title="employeehours" storeModule='budget' :endpoint="getEndpoint(props.row['Employee id'])"></app-chart-component>
                                        </div>
                                        <div class="col-6">
                                            <app-table-component ref="table" title="employeetable" :endpoint="getTableEndpoint(props.row['Employee id'])"></app-table-component>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-for="col in employeeTableHeaders"
                                :key="col.key"
                                :prop="col.prop"
                                :label="col.label"
                                :formatter="formatter"
                            >
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import axios from '@/services/axios.js'
import { getTableHeaders, getHeadersWithAccessToken } from '../../functions.js'
import ChartComponent from '../../chart/ChartComponent'
import TableComponent from '../../table/TableComponent'
import GraphFilter from '../../components/GraphFilter'

export default {
    data () {
        return {
            employeeTableData: [],
            employeeTableHeaders: [],
            storeTableData: [],
            storeTableHeaders: [],
            employeeLoaded: false,
            storeLoaded: false,
            storeSelected: null,
            collapse: true,
            topLoading: true,
            bottomLoading: true,
            numRecords: 10
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appChartComponent: ChartComponent,
        appTableComponent: TableComponent,
        appGraphFilter: GraphFilter
    },
    computed: {
        productivitySwitch: {
            get () {
                return this.$store.state.graphFilter.productivitySwitch
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_PRODUCTIVITY_SWITCH', value)
                this.update()
            }
        },
        filteredStoreTableData () {
            if (this.storeTableData.length === 0) {
                return this.storeTableData
            } else {
                if (this.storeTableData.length > (this.numRecords - 1)) {
                    let newData = []
                    let data = this.sortRankData()
                    for (let idx = 0; idx < (this.numRecords / 2); idx++) {
                        if (data[idx] !== undefined) {
                            newData.push(data[idx])
                        }
                    }
                    for (let idx = data.length - 1; idx >= data.length - (this.numRecords / 2); idx--) {
                        if (data[idx] !== undefined) {
                            newData.push(data[idx])
                        }
                    }
                    return newData.sort((a, b) => (a.Rank) - (b.Rank)) // this.sortRankData(newData)
                } else {
                    return this.storeTableData
                }
            }
        }
    },
    methods: {
        update (onlyEmployee = false) {
            if (this.storeSelected !== null && onlyEmployee === true) { // Must be set otherwise do not make call to endpoint
                this.bottomLoading = true
                if (this.$refs.chartstore !== undefined) {
                    this.$refs.chartstore.draw(this.storeSelected)
                }
                axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/performance/productivity/employee_productivity', {
                    'format': 'aod',
                    'store_id': [this.storeSelected]
                }, { headers: getHeadersWithAccessToken() })
                    .then(response => {
                        let switchValue = this.$store.state.graphFilter.productivitySwitch
                        this.employeeTableData = response.data.data.sort((a, b) => (a[switchValue] < b[switchValue]) ? 1 : -1)
                        this.employeeTableHeaders = getTableHeaders(response.data.columns)
                        this.employeeLoaded = true
                        this.bottomLoading = false
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
            if (onlyEmployee === false) {
                this.topLoading = true
                this.bottomLoading = true
                axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/performance/productivity/store_productivity', {
                    'format': 'aod',
                    'store_id': this.$store.getters['graphFilter/getStoreIds']
                }, { headers: getHeadersWithAccessToken() })
                    .then(response => {
                        this.storeTableHeaders = getTableHeaders(response.data.columns)
                        let storeObj = this.storeTableHeaders.find(x => x.prop === 'store_id')
                        let idx = this.storeTableHeaders.indexOf(storeObj)
                        this.storeTableHeaders.splice(idx, 1)
                        this.storeTableData = this.sortRankData(response.data.data)
                        // Get the unique stores from this list
                        this.storeSelected = this.storeTableData[0]['store_id']
                        this.update(true)
                        this.storeLoaded = true
                        this.topLoading = false
                        this.bottomLoading = false
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
        sortRankData (data = this.storeTableData) {
            // Sort the list
            let switchValue = this.$store.state.graphFilter.productivitySwitch
            let newData = []
            // First remove null values
            for (let obj of data) {
                if (obj[switchValue] !== null && obj[switchValue] !== undefined) {
                    newData.push(obj)
                }
            }
            // Sort the list
            newData = newData.sort((a, b) => (a[switchValue] < b[switchValue]) ? 1 : -1)
            // Set the rank
            for (let i = 0; i < newData.length; i++) {
                newData[i]['Rank'] = parseInt(i + 1)
            }
            // newData = [...new Map(newData.map(item => [item['store_id'], item])).values()]
            return newData
        },
        getEndpoint (id) {
            return '/performance/productivity/employee_detail?employee_id=' + String(id)
        },
        getTableEndpoint (id) {
            return '/performance/productivity/employee_contracts?employee_id=' + String(id)
        },
        collapseOpenRow (row, expanded) {
            if (expanded.length === 0) {
                document.getElementsByClassName('el-table__expand-icon--expanded')[0].click()
            }
            if (document.getElementsByClassName('el-table__expand-icon--expanded').length > 0) {
                if (expanded) {
                    document.getElementsByClassName('el-table__expand-icon--expanded')[0].click()
                }
            }
        },
        tableRowClassName ({ row, rowIndex }) {
            if (row['store_id'] === this.storeSelected) {
                return 'highlight-row'
            }
        },
        rowClicked (row) {
            try {
                this.$refs.employeeProductivityTable.toggleRowExpansion(row)
            } catch (error) {
                // Only expand parent rows
            }
        },
        storeRowClicked (row) {
            this.storeSelected = row['store_id']
            this.update(true)
        },
        columnStyling (param) {
            const { column } = param
            if (column.property === this.$store.state.graphFilter.productivitySwitch) {
                return { fontWeight: '800', color: '#606266' }
            }
        },
        cellStyling (param) {
            const { column, row } = param
            if (column.property === 'Rank' && row[column.property] !== null) {
                let val = row[this.$store.state.graphFilter.productivitySwitch]
                let count = 0
                for (let d of this.filteredStoreTableData) {
                    if (d[this.$store.state.graphFilter.productivitySwitch] > val) {
                        count += 1
                    }
                }
                if (this.filteredStoreTableData.length === 1) {
                    return { }
                } else if (count >= Math.round(this.filteredStoreTableData.length / 2)) {
                    return { color: '#de1738', fontWeight: '800' }
                } else {
                    return { color: '#2e8b57', fontWeight: '800' }
                }
            }
            if (column.property === this.$store.state.graphFilter.productivitySwitch && row[column.property] !== null) {
                return { fontWeight: '800' }
            }
        },
        formatter (row, column, value, index) {
            if (row[column.property] !== undefined && row[column.property] !== null) {
                if (['Age', 'Experience (months)', 'ROI'].includes(column.property)) {
                    return row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 0 })
                } else if (column.property === 'AOV' || column.property === 'Prod') {
                    return '€' + row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 0 })
                } else if (column.property === 'Hourly rate') {
                    return '€' + row[column.property].toLocaleString('en-EN', { minimumFractionDigits: 2 })
                } else if (column.property === 'Conv') {
                    return row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 0 }) + '%'
                } else {
                    return row[column.property]
                }
            }
        },
        getVariableName () {
            if (this.$store.state.graphFilter.productivitySwitch === 'AOV') {
                return 'average order value'
            } else if (this.$store.state.graphFilter.productivitySwitch === 'Conv') {
                return 'conversion'
            } else if (this.$store.state.graphFilter.productivitySwitch === 'Prod') {
                return 'productivity per hour'
            } else {
                return 'return on investment'
            }
        }
    },
    mounted () {
        this.topLoading = true
    }
}
</script>
<style lang="scss">
.performance-productivity {
    .highlight-row {
        background-color: #f5f7fa;
    }
    .el-divider--horizontal {
        margin: 75px 0px;
        height: 2px;
    }
}
</style>
